import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, unref as _unref, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-8d7d2282"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "batch_add_task" }
const _hoisted_2 = { style: {"display":"flex","align-items":"center","gap":"10px","margin-bottom":"15px","flex-wrap":"wrap"} }
const _hoisted_3 = {
  key: 0,
  style: {"font-size":"14px","font-weight":"bold","color":"#303133"}
}
const _hoisted_4 = /*#__PURE__*/_createTextVNode("+ 添加任务")
const _hoisted_5 = /*#__PURE__*/_createTextVNode("保存到草稿")
const _hoisted_6 = { style: {"color":"#909399","font-size":"12px"} }
const _hoisted_7 = ["title"]
const _hoisted_8 = ["title"]
const _hoisted_9 = { class: "col-header" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "任务标题", -1))
const _hoisted_11 = { style: {"display":"flex","align-items":"center"} }
const _hoisted_12 = {
  key: 0,
  class: "level-indent",
  style: {"color":"#409EFF","font-weight":"bold"}
}
const _hoisted_13 = {
  key: 1,
  class: "level-indent",
  style: {"color":"#E6A23C","font-weight":"bold"}
}
const _hoisted_14 = {
  key: 2,
  class: "level-indent",
  style: {"color":"#909399","font-weight":"bold"}
}
const _hoisted_15 = /*#__PURE__*/_createTextVNode("子")
const _hoisted_16 = /*#__PURE__*/_createTextVNode("孙")
const _hoisted_17 = { class: "col-header" }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "开始时间", -1))
const _hoisted_19 = { class: "col-header" }
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "结束时间", -1))
const _hoisted_21 = { class: "col-header" }
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "事项类型", -1))
const _hoisted_23 = { class: "col-header" }
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "任务类型", -1))
const _hoisted_25 = { class: "col-header" }
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "计量总值", -1))
const _hoisted_27 = { class: "col-header" }
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "计量总工时", -1))
const _hoisted_29 = { class: "col-header" }
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "任务描述", -1))
const _hoisted_31 = { class: "col-header" }
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "来源人", -1))
const _hoisted_33 = { class: "col-header" }
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "执行人", -1))
const _hoisted_35 = { class: "col-header" }
const _hoisted_36 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "审核人", -1))
const _hoisted_37 = { class: "col-header" }
const _hoisted_38 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "状态", -1))
const _hoisted_39 = /*#__PURE__*/_createTextVNode()
const _hoisted_40 = /*#__PURE__*/_createTextVNode("+子")
const _hoisted_41 = /*#__PURE__*/_createTextVNode("↑")
const _hoisted_42 = /*#__PURE__*/_createTextVNode("↓")
const _hoisted_43 = /*#__PURE__*/_createTextVNode("删除")
const _hoisted_44 = {
  key: 0,
  style: {"text-align":"center","padding":"40px","color":"#999"}
}
const _hoisted_45 = { style: {"margin-top":"15px","display":"flex","justify-content":"center","gap":"10px"} }
const _hoisted_46 = /*#__PURE__*/_createTextVNode("取 消")
const _hoisted_47 = /*#__PURE__*/_createTextVNode("保存到草稿")
const _hoisted_48 = /*#__PURE__*/_createTextVNode("批量提交")

import { ref, onMounted, computed } from 'vue';
	import { ElMessage } from 'element-plus';
	import { CopyDocument } from '@element-plus/icons-vue';
	import { apiName, requestMyuser } from '@/api/api';
	import { requestAddTask, xmUser, xmDetails2, requestProjectAllList, requestAllTaskList, requestTaskGanttList } from '@/api/xmApi';
	import { requestGetAllConfig } from '@/api/configApi';

	
export default /*#__PURE__*/_defineComponent({
  name: 'BatchAddTask',
  props: {
		projectId: { type: [Number, String], default: 0 }
	},
  emits: ['cancelTask'],
  setup(__props, { emit }) {

const props = __props

	
	

	const api = ref(apiName);
	const projectInfo = ref<any>(null);
	const taskList = ref<any[]>([]);
	const submitting = ref(false);
	const submitProgress = ref({ current: 0, total: 0, success: 0, error: '' });
	const userLists = ref<any[]>([]);
	const sxlxLists = ref<any[]>([]);
	// 全部项目：用于"所属项目"下拉（支持跨项目创建）
	const projectLists = ref<any[]>([]);
	// 任务类型（通用任务/计量任务/定额任务等）
	const type2Lists = ref<any[]>([]);
	const myUserId = ref('');
	let uidCounter = 0;

	// 草稿：按 项目 + 当前用户 隔离存储于 localStorage
	const draftKey = computed(() => `batchAddTask_draft_${props.projectId || ''}_${myUserId.value}`);
	const saveDraft = () => {
		try {
			if (taskList.value.length === 0) {
				ElMessage.warning('暂无可保存的草稿');
				return;
			}
			localStorage.setItem(draftKey.value, JSON.stringify(taskList.value));
			ElMessage.success('草稿已保存');
		} catch (e) {
			ElMessage.error('草稿保存失败');
		}
	};
	const loadDraft = () => {
		const raw = localStorage.getItem(draftKey.value);
		if (!raw) return false;
		try {
			const arr = JSON.parse(raw);
			if (Array.isArray(arr) && arr.length > 0) {
				// 恢复 uid 计数器，避免新行 uid 冲突
				arr.forEach((r: any) => {
					const m = /batch_(\d+)_/.exec(r.uid || '');
					if (m) uidCounter = Math.max(uidCounter, parseInt(m[1]));
				});
				// 兼容旧草稿：补齐新增字段，并为已选上级任务补回候选项（避免下拉只显示 id）
				arr.forEach((r: any) => {
					if (r.parentOptions == null) r.parentOptions = [];
					ensureParentOption(r);
				});
				taskList.value = arr;
				ElMessage.info('已自动读取上次保存的草稿');
				return true;
			}
		} catch (e) {
			// 草稿损坏则忽略
		}
		return false;
	};
	const clearDraft = () => {
		localStorage.removeItem(draftKey.value);
	};

	const createEmptyRow = (level: number): any => {
		const today = new Date();
		const fmt = (d: Date) => {
			const y = d.getFullYear();
			const m = String(d.getMonth() + 1).padStart(2, '0');
			const dd = String(d.getDate()).padStart(2, '0');
			return `${y}-${m}-${dd}`;
		};
		const tomorrow = new Date(today);
		tomorrow.setDate(tomorrow.getDate() + 1);
		return {
			uid: `batch_${++uidCounter}_${Date.now()}`,
			level,
			startdate: fmt(today),
			enddate: fmt(tomorrow),
			tasktitle: '',
			type1: '',
			type2: '通用任务',
			maxjl: '',
			maxjlgs: '',
			taskdescribe: '',
			lyname: '',
			ly: '',
			zxr: '',
			shr: '',
			status: 1,
			fileList: [],
			// 所属项目：默认取传入的项目（跨项目创建时由用户选择）
			projectid: props.projectId ? Number(props.projectId) : '',
			// 上级任务：0=顶级任务；可选同项目/跨项目的已有任务
			taskpid: 0,
			taskpidLabel: '',
			// 上级任务下拉候选（按行保存，避免多行互相覆盖）
			parentOptions: []
		};
	};

	const rowStyle = ({ row }: any) => {
		return { paddingLeft: `${row.level * 40}px` };
	};

	const rowClassName = ({ row }: any) => {
		if (row.level === 0) return 'row-level-0';
		if (row.level === 1) return 'row-level-1';
		return 'row-level-2';
	};

	const addRootTask = () => {
		taskList.value.push(createEmptyRow(0));
	};

	const addChildTask = (index: number) => {
		const parentLevel = taskList.value[index].level;
		// 找到该父任务所有后代之后的位置
		let insertAt = index + 1;
		while (insertAt < taskList.value.length && taskList.value[insertAt].level > parentLevel) {
			insertAt++;
		}
		taskList.value.splice(insertAt, 0, createEmptyRow(parentLevel + 1));
	};

	const removeRow = (index: number) => {
		const level = taskList.value[index].level;
		let count = 1;
		// 删除所有后代（level > 当前行的连续后续行）
		while (index + count < taskList.value.length && taskList.value[index + count].level > level) {
			count++;
		}
		taskList.value.splice(index, count);
	};

	// 获取一个任务块的范围 [start, end)
	const getBlockRange = (index: number): [number, number] => {
		const level = taskList.value[index].level;
		let end = index + 1;
		while (end < taskList.value.length && taskList.value[end].level > level) {
			end++;
		}
		return [index, end];
	};

	const moveUp = (index: number) => {
		if (index === 0) return;
		const level = taskList.value[index].level;
		// 找到上一个同级任务的index
		let prevIndex = index - 1;
		while (prevIndex >= 0 && taskList.value[prevIndex].level > level) {
			prevIndex--;
		}
		if (prevIndex < 0 || taskList.value[prevIndex].level !== level) return;

		const [currStart, currEnd] = getBlockRange(index);
		const [prevStart, prevEnd] = getBlockRange(prevIndex);

		// 交换两个块
		const currBlock = taskList.value.splice(currStart, currEnd - currStart);
		const prevBlock = taskList.value.splice(prevStart, prevEnd - prevStart);
		taskList.value.splice(prevStart, 0, ...currBlock);
		taskList.value.splice(prevStart + currBlock.length, 0, ...prevBlock);
	};

	const moveDown = (index: number) => {
		const level = taskList.value[index].level;
		const [currStart, currEnd] = getBlockRange(index);
		if (currEnd >= taskList.value.length) return;
		// 找到下一个同级任务
		let nextIndex = currEnd;
		if (nextIndex >= taskList.value.length || taskList.value[nextIndex].level !== level) return;

		const [nextStart, nextEnd] = getBlockRange(nextIndex);
		const currBlock = taskList.value.splice(currStart, currEnd - currStart);
		const nextBlock = taskList.value.splice(currStart, nextEnd - currStart - (currEnd - currStart));
		// 先插入next块，再插入curr块
		taskList.value.splice(currStart, 0, ...nextBlock);
		taskList.value.splice(currStart + nextBlock.length, 0, ...currBlock);
	};

	// 复制首行值到该列下方所有空单元格（文本框/下拉选择均适用）
	const copyColumn = (field: string) => {
		if (taskList.value.length < 1) return;
		const firstVal = taskList.value[0][field];
		let filled = 0;
		taskList.value.forEach((row: any, i: number) => {
			if (i === 0) return; // 保留首行
			if (row[field] === '' || row[field] == null) {
				row[field] = firstVal;
				filled++;
			}
		});
		if (filled > 0) {
			ElMessage.success(`已复制首行内容到 ${filled} 个空单元格`);
		} else {
			ElMessage.info('下方没有需要复制的空单元格');
		}
	};

	// ===== 所属项目 / 上级任务 =====
// 切换所属项目：清空已选上级任务，并预加载该项目下的任务供直接选择
const onProjectChange = (row: any) => {
	row.taskpid = 0;
	row.taskpidLabel = '';
	loadProjectTasks(row);
};
// 预加载指定项目下的非关闭任务
const loadProjectTasks = (row: any) => {
	const pid = Number(row.projectid) || 0;
	row.parentOptions = [];
	if (!pid) return;
	requestTaskGanttList({ projectid: pid }).then((res: any) => {
		const arr = Array.isArray(res) ? res : ((res && res.datalist) || []);
		row.parentOptions = arr.map((t: any) => ({
			id: t.id,
			label: t.tasktitle,
			projectid: t.projectid
		}));
		ensureParentOption(row);
	});
};
// 上级任务远程搜索：按关键字跨项目搜索（返回项带 projectid，便于自动带出所属项目）
const searchParentTask = (row: any, keyword: string) => {
	requestAllTaskList({
		pageIndex: 1,
		pageSize: 50,
		status: 0,
		liketxt: keyword || ''
	}).then((res: any) => {
		const rows = (res && res.data) || [];
		row.parentOptions = rows.map((r: any) => {
			const c = r.cell || r;
			return {
				id: c.id,
				label: c.projectname ? `${c.projectname} - ${c.tasktitle}` : c.tasktitle,
				projectid: c.projectid
			};
		});
		ensureParentOption(row);
	});
};
// 展开上级任务下拉：已选项目则列出该项目任务，否则跨项目按关键字搜索
const onParentFocus = (row: any) => {
	if (Number(row.projectid)) {
		loadProjectTasks(row);
	} else {
		searchParentTask(row, '');
	}
};
// 选择上级任务后，默认带出该任务所属项目
const onParentTaskChange = (row: any) => {
	const tid = Number(row.taskpid) || 0;
	if (!tid) {
		row.taskpidLabel = '';
		return;
	}
	const t = (row.parentOptions || []).find((x: any) => Number(x.id) === tid);
	if (t) {
		row.taskpidLabel = t.label;
		if (t.projectid) {
			row.projectid = Number(t.projectid);
		}
	}
};
// 草稿恢复等场景下，保证已选上级任务有候选项，避免下拉框只显示 id
const ensureParentOption = (row: any) => {
	const tid = Number(row.taskpid) || 0;
	if (!tid) return;
	if (!(row.parentOptions || []).some((x: any) => Number(x.id) === tid)) {
		row.parentOptions = [{
			id: tid,
			label: row.taskpidLabel || `任务#${tid}`,
			projectid: row.projectid
		}];
	}
};
// 向上查找父任务行索引
const findParentIndex = (index: number): number => {
	const row = taskList.value[index];
	if (!row) return -1;
	for (let j = index - 1; j >= 0; j--) {
		if (taskList.value[j].level === row.level - 1) return j;
	}
	return -1;
};
// 行的所属项目：子任务继承父任务行的项目
const getRowProjectId = (index: number): number => {
	const row = taskList.value[index];
	if (!row) return 0;
	if (row.level === 0) return Number(row.projectid) || Number(props.projectId) || 0;
	const pi = findParentIndex(index);
	if (pi < 0) return Number(row.projectid) || Number(props.projectId) || 0;
	return getRowProjectId(pi);
};
const getProjectName = (pid: any): string => {
	const p = projectLists.value.find((x: any) => Number(x.id) === Number(pid));
	return p ? `${p.code}-${p.projectname}` : '';
};
// 子任务行展示：继承的所属项目
const getInheritedProjectName = (index: number): string => {
	const pi = findParentIndex(index);
	if (pi < 0) return '';
	return getProjectName(getRowProjectId(pi));
};
// 子任务行展示：继承的上级任务（父行标题）
const getParentRowTitle = (index: number): string => {
	const pi = findParentIndex(index);
	if (pi < 0) return '';
	return taskList.value[pi].tasktitle || '';
};

const onUpload = (row: any, res: any, file: any) => {
		if (res.errno === 0 && res.data && res.data[0]) {
			const rawName = res.data[0].name ? decodeURIComponent(res.data[0].name) : file.name
			row.fileList.push(res.data[0].url + (rawName ? '|' + rawName : ''))
		}
	};

	// 校验单行
	const validateRow = (row: any, index: number): string => {
		const prefix = row.level > 0 ? `[子任务${index + 1}]` : `[任务${index + 1}]`;
		// 所属项目：仅顶级任务需要选择；子任务继承父任务行的项目
		if (row.level === 0 && !getRowProjectId(index)) return `${prefix} 请选择所属项目`;
		if (!row.startdate) return `${prefix} 请填写开始时间`;
		if (!row.enddate) return `${prefix} 请填写结束时间`;
		if (!row.tasktitle.trim()) return `${prefix} 请填写任务标题`;
		if (!row.type1) return `${prefix} 请选择事项类型`;
		if (!row.type2) return `${prefix} 请选择任务类型`;
		// 计量任务必须填写有效的计量总工时（与单个新建任务校验一致）
		if (row.type2 === '计量任务') {
			if (row.maxjlgs === '' || row.maxjlgs == null) return `${prefix} 计量任务，计量总工时不可为空`;
			if (isNaN(parseFloat(row.maxjlgs))) return `${prefix} 计量总工时请输入数字`;
			if (parseFloat(row.maxjlgs) <= 0) return `${prefix} 计量总工时请输入大于0数字`;
		}
		if (!row.taskdescribe.trim()) return `${prefix} 请填写任务描述`;
		if (!row.lyname) return `${prefix} 请选择任务来源人`;
		if (!row.zxr) return `${prefix} 请选择执行人`;
		if (!row.shr) return `${prefix} 请选择审核人`;
		return '';
	};

	// 提交单个任务
	const submitOneTask = async (row: any, parentTaskId: number, projectid: number): Promise<string> => {
		const zxrParts = row.zxr ? row.zxr.split(',') : ['0', ''];
		const shrParts = row.shr ? row.shr.split(',') : ['0', ''];
		const lyParts = row.lyname ? row.lyname.split(',') : ['0', ''];
		const fileUrls = row.fileList.join(',');

		const res: any = await requestAddTask({
			projectid: projectid,
			taskpid: parentTaskId,
			type1: row.type1,
			startdate: row.startdate,
			enddate: row.enddate,
			tasktitle: row.tasktitle,
			taskdescribe: row.taskdescribe,
			operatoruserid: parseInt(zxrParts[0]) || 0,
			operatorname: zxrParts[1] || '',
			checkuserid: parseInt(shrParts[0]) || 0,
			checkname: shrParts[1] || '',
			status: row.status,
			filelist: fileUrls,
			type2: row.type2 || '通用任务',
			maxjl: row.maxjl === '' || row.maxjl == null ? '0' : String(row.maxjl),
			maxjlgs: row.maxjlgs === '' || row.maxjlgs == null ? '0' : String(row.maxjlgs),
			jmtype: '',
			lyname: lyParts[1] || '',
			ly: '无',
			type3: '',
			type4jsonstr: ''
		});
		if (res.status !== 1) {
			throw new Error(res.msg || '创建失败');
		}
		return res.datalist || '0';
	};

	// 批量提交
	const submitAll = async () => {
		if (taskList.value.length === 0) {
			ElMessage.warning('请先添加任务');
			return;
		}
		// 校验
		for (let i = 0; i < taskList.value.length; i++) {
			const err = validateRow(taskList.value[i], i);
			if (err) {
				ElMessage.error(err);
				return;
			}
		}

		submitting.value = true;
		submitProgress.value = { current: 0, total: taskList.value.length, success: 0, error: '' };

		// 已创建的任务ID映射: uid -> newTaskId
		const createdIds: Record<string, string> = {};

		try {
			for (let i = 0; i < taskList.value.length; i++) {
				submitProgress.value.current = i + 1;
				const row = taskList.value[i];

				// 父任务ID：子任务沿用层级父任务；顶级任务取本行选择的上级任务
				let parentTaskId = 0;
				if (row.level > 0) {
					// 向上找第一个 level-1 的任务
					for (let j = i - 1; j >= 0; j--) {
						if (taskList.value[j].level === row.level - 1) {
							const pid = createdIds[taskList.value[j].uid];
							if (pid) {
								parentTaskId = parseInt(pid) || 0;
							}
							break;
						}
					}
				} else {
					parentTaskId = Number(row.taskpid) || 0;
				}

				const newId = await submitOneTask(row, parentTaskId, getRowProjectId(i));
				createdIds[row.uid] = newId;
				submitProgress.value.success++;
			}

			ElMessage({ message: `成功创建 ${submitProgress.value.success} 个任务`, type: 'success', duration: 1500 });
			clearDraft();
			setTimeout(() => {
				emit('cancelTask', 1);
			}, 1500);
		} catch (e: any) {
			submitProgress.value.error = e.message || '未知错误';
			ElMessage.error(`提交失败: ${e.message || '未知错误'}，已成功 ${submitProgress.value.success} 个`);
		} finally {
			submitting.value = false;
		}
	};

	const cancel = () => {
		emit('cancelTask');
	};

	onMounted(() => {
		// 当前用户信息（草稿按用户隔离）
		requestMyuser({}).then((res: any) => {
			if (res.status === 1 && res.datalist && res.datalist[0]) {
				myUserId.value = res.datalist[0].id;
				// 自动读取该用户在当前项目下的草稿
				if (!loadDraft()) {
					if (taskList.value.length === 0) addRootTask();
				}
			} else {
				if (taskList.value.length === 0) addRootTask();
			}
		});
		// 加载项目信息
		xmDetails2({ id: props.projectId }).then((res: any) => {
			if (res.status === 1 && res.datalist && res.datalist.length > 0) {
				projectInfo.value = res.datalist[0];
			}
		});
		// 加载用户列表
		xmUser().then((res: any) => {
			if (res.status === 1) {
				userLists.value = res.datalist || [];
			}
		});
		// 加载事项类型
		requestGetAllConfig({ type: '事项类型' }).then((res: any) => {
			if (res.status === 1) {
				sxlxLists.value = res.datalist || [];
			}
		});
		// 加载全部项目（所属项目下拉，支持跨项目创建）
		requestProjectAllList({}).then((res: any) => {
			if (res.status === 1) {
				projectLists.value = res.datalist || [];
			}
		});
		// 加载任务类型
		requestGetAllConfig({ type: 'tasktype2' }).then((res: any) => {
			if (res.status === 1) {
				type2Lists.value = res.datalist || [];
			}
		});
		});

return (_ctx: any,_cache: any) => {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_tag = _resolveComponent("el-tag")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_date_picker = _resolveComponent("el-date-picker")!
  const _component_el_upload = _resolveComponent("el-upload")!
  const _component_el_table = _resolveComponent("el-table")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (projectInfo.value)
        ? (_openBlock(), _createElementBlock("span", _hoisted_3, _toDisplayString(projectInfo.value.code) + " - " + _toDisplayString(projectInfo.value.projectname), 1))
        : _createCommentVNode("", true),
      _createVNode(_component_el_button, {
        type: "primary",
        onClick: addRootTask
      }, {
        default: _withCtx(() => [
          _hoisted_4
        ]),
        _: 1
      }),
      _createVNode(_component_el_button, {
        type: "warning",
        onClick: saveDraft
      }, {
        default: _withCtx(() => [
          _hoisted_5
        ]),
        _: 1
      }),
      _createVNode(_component_el_button, {
        type: "success",
        onClick: submitAll,
        loading: submitting.value
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(submitting.value ? `提交中 (${submitProgress.value.current}/${submitProgress.value.total})` : '批量提交'), 1)
        ]),
        _: 1
      }, 8, ["loading"]),
      _createElementVNode("span", _hoisted_6, "共 " + _toDisplayString(taskList.value.length) + " 条任务", 1),
      (submitProgress.value.total > 0)
        ? (_openBlock(), _createElementBlock("span", {
            key: 1,
            style: _normalizeStyle([{"font-size":"12px"}, {color: submitProgress.value.error ? '#F56C6C' : '#67C23A'}])
          }, _toDisplayString(submitProgress.value.error ? `失败: ${submitProgress.value.error}` : `成功: ${submitProgress.value.success}`), 5))
        : _createCommentVNode("", true)
    ]),
    _createVNode(_component_el_table, {
      data: taskList.value,
      border: "",
      size: "small",
      "row-style": rowStyle,
      "row-class-name": rowClassName,
      "header-cell-style": {fontSize:'12px'}
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_table_column, {
          label: "所属项目",
          width: "190"
        }, {
          default: _withCtx(({$index, row}) => [
            (row.level === 0)
              ? (_openBlock(), _createBlock(_component_el_select, {
                  key: 0,
                  modelValue: row.projectid,
                  "onUpdate:modelValue": ($event: any) => ((row.projectid) = $event),
                  placeholder: "请选择项目",
                  size: "small",
                  filterable: "",
                  style: {"width":"100%"},
                  onChange: ($event: any) => (onProjectChange(row))
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(projectLists.value, (p) => {
                      return (_openBlock(), _createBlock(_component_el_option, {
                        key: p.id,
                        label: `${p.code}-${p.projectname}`,
                        value: Number(p.id)
                      }, null, 8, ["label", "value"]))
                    }), 128))
                  ]),
                  _: 2
                }, 1032, ["modelValue", "onUpdate:modelValue", "onChange"]))
              : (_openBlock(), _createElementBlock("span", {
                  key: 1,
                  class: "inherit-txt",
                  title: getInheritedProjectName($index)
                }, "继承 " + _toDisplayString(getInheritedProjectName($index) || '上级任务所属项目'), 9, _hoisted_7))
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, {
          label: "上级任务",
          width: "230"
        }, {
          default: _withCtx(({$index, row}) => [
            (row.level === 0)
              ? (_openBlock(), _createBlock(_component_el_select, {
                  key: 0,
                  modelValue: row.taskpid,
                  "onUpdate:modelValue": ($event: any) => ((row.taskpid) = $event),
                  placeholder: "输入关键字搜索（可跨项目）",
                  size: "small",
                  filterable: "",
                  remote: "",
                  clearable: "",
                  "reserve-keyword": "",
                  "remote-method": (q)=>searchParentTask(row,q),
                  style: {"width":"100%"},
                  onChange: ($event: any) => (onParentTaskChange(row)),
                  onFocus: ($event: any) => (onParentFocus(row))
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_option, {
                      label: "无（作为顶级任务）",
                      value: 0
                    }),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(row.parentOptions, (t) => {
                      return (_openBlock(), _createBlock(_component_el_option, {
                        key: t.id,
                        label: t.label,
                        value: Number(t.id)
                      }, null, 8, ["label", "value"]))
                    }), 128))
                  ]),
                  _: 2
                }, 1032, ["modelValue", "onUpdate:modelValue", "remote-method", "onChange", "onFocus"]))
              : (_openBlock(), _createElementBlock("span", {
                  key: 1,
                  class: "inherit-txt",
                  title: getParentRowTitle($index)
                }, "继承 " + _toDisplayString(getParentRowTitle($index) || '上级任务'), 9, _hoisted_8))
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, {
          label: "任务标题",
          "min-width": "220"
        }, {
          header: _withCtx(() => [
            _createElementVNode("div", _hoisted_9, [
              _hoisted_10,
              _createVNode(_component_el_button, {
                link: "",
                type: "primary",
                icon: _unref(CopyDocument),
                size: "small",
                title: "复制首行到下方空单元格",
                disabled: taskList.value.length < 1,
                onClick: _cache[0] || (_cache[0] = ($event: any) => (copyColumn('tasktitle')))
              }, null, 8, ["icon", "disabled"])
            ])
          ]),
          default: _withCtx(({row}) => [
            _createElementVNode("div", _hoisted_11, [
              (row.level===1)
                ? (_openBlock(), _createElementBlock("span", _hoisted_12, "├─ "))
                : (row.level===2)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_13, "│  └─ "))
                  : (row.level>=3)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_14, "│    └─ "))
                    : _createCommentVNode("", true),
              (row.level===1)
                ? (_openBlock(), _createBlock(_component_el_tag, {
                    key: 3,
                    size: "small",
                    type: "warning",
                    style: {"margin-right":"4px","font-size":"10px"}
                  }, {
                    default: _withCtx(() => [
                      _hoisted_15
                    ]),
                    _: 1
                  }))
                : (row.level>=2)
                  ? (_openBlock(), _createBlock(_component_el_tag, {
                      key: 4,
                      size: "small",
                      type: "danger",
                      style: {"margin-right":"4px","font-size":"10px"}
                    }, {
                      default: _withCtx(() => [
                        _hoisted_16
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true),
              _createVNode(_component_el_input, {
                modelValue: row.tasktitle,
                "onUpdate:modelValue": ($event: any) => ((row.tasktitle) = $event),
                placeholder: "任务标题",
                size: "small"
              }, null, 8, ["modelValue", "onUpdate:modelValue"])
            ])
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, {
          label: "开始时间",
          width: "130"
        }, {
          header: _withCtx(() => [
            _createElementVNode("div", _hoisted_17, [
              _hoisted_18,
              _createVNode(_component_el_button, {
                link: "",
                type: "primary",
                icon: _unref(CopyDocument),
                size: "small",
                title: "复制首行到下方空单元格",
                disabled: taskList.value.length < 1,
                onClick: _cache[1] || (_cache[1] = ($event: any) => (copyColumn('startdate')))
              }, null, 8, ["icon", "disabled"])
            ])
          ]),
          default: _withCtx(({row}) => [
            _createVNode(_component_el_date_picker, {
              modelValue: row.startdate,
              "onUpdate:modelValue": ($event: any) => ((row.startdate) = $event),
              type: "date",
              placeholder: "开始",
              "value-format": "YYYY-MM-DD",
              size: "small",
              style: {"width":"110px"}
            }, null, 8, ["modelValue", "onUpdate:modelValue"])
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, {
          label: "结束时间",
          width: "130"
        }, {
          header: _withCtx(() => [
            _createElementVNode("div", _hoisted_19, [
              _hoisted_20,
              _createVNode(_component_el_button, {
                link: "",
                type: "primary",
                icon: _unref(CopyDocument),
                size: "small",
                title: "复制首行到下方空单元格",
                disabled: taskList.value.length < 1,
                onClick: _cache[2] || (_cache[2] = ($event: any) => (copyColumn('enddate')))
              }, null, 8, ["icon", "disabled"])
            ])
          ]),
          default: _withCtx(({row}) => [
            _createVNode(_component_el_date_picker, {
              modelValue: row.enddate,
              "onUpdate:modelValue": ($event: any) => ((row.enddate) = $event),
              type: "date",
              placeholder: "结束",
              "value-format": "YYYY-MM-DD",
              size: "small",
              style: {"width":"110px"}
            }, null, 8, ["modelValue", "onUpdate:modelValue"])
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, {
          label: "事项类型",
          width: "110"
        }, {
          header: _withCtx(() => [
            _createElementVNode("div", _hoisted_21, [
              _hoisted_22,
              _createVNode(_component_el_button, {
                link: "",
                type: "primary",
                icon: _unref(CopyDocument),
                size: "small",
                title: "复制首行到下方空单元格",
                disabled: taskList.value.length < 1,
                onClick: _cache[3] || (_cache[3] = ($event: any) => (copyColumn('type1')))
              }, null, 8, ["icon", "disabled"])
            ])
          ]),
          default: _withCtx(({row}) => [
            _createVNode(_component_el_select, {
              modelValue: row.type1,
              "onUpdate:modelValue": ($event: any) => ((row.type1) = $event),
              placeholder: "选择",
              size: "small",
              style: {"width":"95px"}
            }, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(sxlxLists.value, (item) => {
                  return (_openBlock(), _createBlock(_component_el_option, {
                    key: item.value,
                    label: item.value,
                    value: item.value
                  }, null, 8, ["label", "value"]))
                }), 128))
              ]),
              _: 2
            }, 1032, ["modelValue", "onUpdate:modelValue"])
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, {
          label: "任务类型",
          width: "110"
        }, {
          header: _withCtx(() => [
            _createElementVNode("div", _hoisted_23, [
              _hoisted_24,
              _createVNode(_component_el_button, {
                link: "",
                type: "primary",
                icon: _unref(CopyDocument),
                size: "small",
                title: "复制首行到下方空单元格",
                disabled: taskList.value.length < 1,
                onClick: _cache[4] || (_cache[4] = ($event: any) => (copyColumn('type2')))
              }, null, 8, ["icon", "disabled"])
            ])
          ]),
          default: _withCtx(({row}) => [
            _createVNode(_component_el_select, {
              modelValue: row.type2,
              "onUpdate:modelValue": ($event: any) => ((row.type2) = $event),
              placeholder: "选择",
              size: "small",
              style: {"width":"95px"}
            }, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(type2Lists.value, (item) => {
                  return (_openBlock(), _createBlock(_component_el_option, {
                    key: item.value,
                    label: item.value,
                    value: item.value
                  }, null, 8, ["label", "value"]))
                }), 128))
              ]),
              _: 2
            }, 1032, ["modelValue", "onUpdate:modelValue"])
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, {
          label: "计量总值",
          width: "110"
        }, {
          header: _withCtx(() => [
            _createElementVNode("div", _hoisted_25, [
              _hoisted_26,
              _createVNode(_component_el_button, {
                link: "",
                type: "primary",
                icon: _unref(CopyDocument),
                size: "small",
                title: "复制首行到下方空单元格",
                disabled: taskList.value.length < 1,
                onClick: _cache[5] || (_cache[5] = ($event: any) => (copyColumn('maxjl')))
              }, null, 8, ["icon", "disabled"])
            ])
          ]),
          default: _withCtx(({row}) => [
            _createVNode(_component_el_input, {
              modelValue: row.maxjl,
              "onUpdate:modelValue": ($event: any) => ((row.maxjl) = $event),
              placeholder: "计量总值",
              size: "small",
              style: {"width":"95px"}
            }, null, 8, ["modelValue", "onUpdate:modelValue"])
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, {
          label: "计量总工时",
          width: "120"
        }, {
          header: _withCtx(() => [
            _createElementVNode("div", _hoisted_27, [
              _hoisted_28,
              _createVNode(_component_el_button, {
                link: "",
                type: "primary",
                icon: _unref(CopyDocument),
                size: "small",
                title: "复制首行到下方空单元格",
                disabled: taskList.value.length < 1,
                onClick: _cache[6] || (_cache[6] = ($event: any) => (copyColumn('maxjlgs')))
              }, null, 8, ["icon", "disabled"])
            ])
          ]),
          default: _withCtx(({row}) => [
            _createVNode(_component_el_input, {
              modelValue: row.maxjlgs,
              "onUpdate:modelValue": ($event: any) => ((row.maxjlgs) = $event),
              placeholder: "计量总工时",
              size: "small",
              style: {"width":"105px"}
            }, null, 8, ["modelValue", "onUpdate:modelValue"])
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, {
          label: "任务描述",
          "min-width": "150"
        }, {
          header: _withCtx(() => [
            _createElementVNode("div", _hoisted_29, [
              _hoisted_30,
              _createVNode(_component_el_button, {
                link: "",
                type: "primary",
                icon: _unref(CopyDocument),
                size: "small",
                title: "复制首行到下方空单元格",
                disabled: taskList.value.length < 1,
                onClick: _cache[7] || (_cache[7] = ($event: any) => (copyColumn('taskdescribe')))
              }, null, 8, ["icon", "disabled"])
            ])
          ]),
          default: _withCtx(({row}) => [
            _createVNode(_component_el_input, {
              modelValue: row.taskdescribe,
              "onUpdate:modelValue": ($event: any) => ((row.taskdescribe) = $event),
              placeholder: "描述",
              size: "small",
              type: "textarea",
              rows: 1
            }, null, 8, ["modelValue", "onUpdate:modelValue"])
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, {
          label: "来源人",
          width: "110"
        }, {
          header: _withCtx(() => [
            _createElementVNode("div", _hoisted_31, [
              _hoisted_32,
              _createVNode(_component_el_button, {
                link: "",
                type: "primary",
                icon: _unref(CopyDocument),
                size: "small",
                title: "复制首行到下方空单元格",
                disabled: taskList.value.length < 1,
                onClick: _cache[8] || (_cache[8] = ($event: any) => (copyColumn('lyname')))
              }, null, 8, ["icon", "disabled"])
            ])
          ]),
          default: _withCtx(({row}) => [
            _createVNode(_component_el_select, {
              modelValue: row.lyname,
              "onUpdate:modelValue": ($event: any) => ((row.lyname) = $event),
              placeholder: "选择",
              size: "small",
              filterable: "",
              style: {"width":"95px"}
            }, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(userLists.value, (u) => {
                  return (_openBlock(), _createBlock(_component_el_option, {
                    key: u.id,
                    label: u.name,
                    value: `${u.id},${u.name}`
                  }, null, 8, ["label", "value"]))
                }), 128))
              ]),
              _: 2
            }, 1032, ["modelValue", "onUpdate:modelValue"])
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, {
          label: "执行人",
          width: "110"
        }, {
          header: _withCtx(() => [
            _createElementVNode("div", _hoisted_33, [
              _hoisted_34,
              _createVNode(_component_el_button, {
                link: "",
                type: "primary",
                icon: _unref(CopyDocument),
                size: "small",
                title: "复制首行到下方空单元格",
                disabled: taskList.value.length < 1,
                onClick: _cache[9] || (_cache[9] = ($event: any) => (copyColumn('zxr')))
              }, null, 8, ["icon", "disabled"])
            ])
          ]),
          default: _withCtx(({row}) => [
            _createVNode(_component_el_select, {
              modelValue: row.zxr,
              "onUpdate:modelValue": ($event: any) => ((row.zxr) = $event),
              placeholder: "选择",
              size: "small",
              filterable: "",
              style: {"width":"95px"}
            }, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(userLists.value, (u) => {
                  return (_openBlock(), _createBlock(_component_el_option, {
                    key: u.id,
                    label: u.name,
                    value: `${u.id},${u.name}`
                  }, null, 8, ["label", "value"]))
                }), 128))
              ]),
              _: 2
            }, 1032, ["modelValue", "onUpdate:modelValue"])
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, {
          label: "审核人",
          width: "110"
        }, {
          header: _withCtx(() => [
            _createElementVNode("div", _hoisted_35, [
              _hoisted_36,
              _createVNode(_component_el_button, {
                link: "",
                type: "primary",
                icon: _unref(CopyDocument),
                size: "small",
                title: "复制首行到下方空单元格",
                disabled: taskList.value.length < 1,
                onClick: _cache[10] || (_cache[10] = ($event: any) => (copyColumn('shr')))
              }, null, 8, ["icon", "disabled"])
            ])
          ]),
          default: _withCtx(({row}) => [
            _createVNode(_component_el_select, {
              modelValue: row.shr,
              "onUpdate:modelValue": ($event: any) => ((row.shr) = $event),
              placeholder: "选择",
              size: "small",
              filterable: "",
              style: {"width":"95px"}
            }, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(userLists.value, (u) => {
                  return (_openBlock(), _createBlock(_component_el_option, {
                    key: u.id,
                    label: u.name,
                    value: `${u.id},${u.name}`
                  }, null, 8, ["label", "value"]))
                }), 128))
              ]),
              _: 2
            }, 1032, ["modelValue", "onUpdate:modelValue"])
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, {
          label: "状态",
          width: "95"
        }, {
          header: _withCtx(() => [
            _createElementVNode("div", _hoisted_37, [
              _hoisted_38,
              _createVNode(_component_el_button, {
                link: "",
                type: "primary",
                icon: _unref(CopyDocument),
                size: "small",
                title: "复制首行到下方空单元格",
                disabled: taskList.value.length < 1,
                onClick: _cache[11] || (_cache[11] = ($event: any) => (copyColumn('status')))
              }, null, 8, ["icon", "disabled"])
            ])
          ]),
          default: _withCtx(({row}) => [
            _createVNode(_component_el_select, {
              modelValue: row.status,
              "onUpdate:modelValue": ($event: any) => ((row.status) = $event),
              placeholder: "状态",
              size: "small",
              style: {"width":"80px"}
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_option, {
                  label: "进行中",
                  value: 1
                }),
                _createVNode(_component_el_option, {
                  label: "关闭",
                  value: 2
                }),
                _createVNode(_component_el_option, {
                  label: "待审核",
                  value: 3
                }),
                _createVNode(_component_el_option, {
                  label: "完成",
                  value: 4
                }),
                _hoisted_39,
                _createVNode(_component_el_option, {
                  label: "未启动",
                  value: 0
                })
              ]),
              _: 2
            }, 1032, ["modelValue", "onUpdate:modelValue"])
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, {
          label: "附件",
          width: "90"
        }, {
          default: _withCtx(({row}) => [
            _createVNode(_component_el_upload, {
              action: `${api.value}/frame/uploadfile1`,
              "show-file-list": false,
              "on-success": (res,file)=>onUpload(row,res,file),
              multiple: ""
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_button, {
                  size: "small",
                  link: "",
                  type: "primary"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(row.fileList.length > 0 ? `${row.fileList.length}个` : '上传'), 1)
                  ]),
                  _: 2
                }, 1024)
              ]),
              _: 2
            }, 1032, ["action", "on-success"])
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, {
          label: "操作",
          width: "175",
          fixed: "right"
        }, {
          default: _withCtx(({$index, row}) => [
            _createVNode(_component_el_button, {
              link: "",
              type: "primary",
              size: "small",
              onClick: ($event: any) => (addChildTask($index))
            }, {
              default: _withCtx(() => [
                _hoisted_40
              ]),
              _: 2
            }, 1032, ["onClick"]),
            _createVNode(_component_el_button, {
              link: "",
              type: "warning",
              size: "small",
              onClick: ($event: any) => (moveUp($index)),
              disabled: $index===0 || taskList.value[$index-1].level < row.level
            }, {
              default: _withCtx(() => [
                _hoisted_41
              ]),
              _: 2
            }, 1032, ["onClick", "disabled"]),
            _createVNode(_component_el_button, {
              link: "",
              type: "warning",
              size: "small",
              onClick: ($event: any) => (moveDown($index)),
              disabled: $index>=taskList.value.length-1
            }, {
              default: _withCtx(() => [
                _hoisted_42
              ]),
              _: 2
            }, 1032, ["onClick", "disabled"]),
            _createVNode(_component_el_button, {
              link: "",
              type: "danger",
              size: "small",
              onClick: ($event: any) => (removeRow($index))
            }, {
              default: _withCtx(() => [
                _hoisted_43
              ]),
              _: 2
            }, 1032, ["onClick"])
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["data"]),
    (taskList.value.length === 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_44, " 暂无任务，请点击\"+ 添加任务\"按钮 "))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_45, [
      _createVNode(_component_el_button, {
        onClick: _cache[12] || (_cache[12] = ($event: any) => (cancel())),
        round: ""
      }, {
        default: _withCtx(() => [
          _hoisted_46
        ]),
        _: 1
      }),
      _createVNode(_component_el_button, {
        type: "warning",
        onClick: saveDraft,
        round: ""
      }, {
        default: _withCtx(() => [
          _hoisted_47
        ]),
        _: 1
      }),
      _createVNode(_component_el_button, {
        type: "primary",
        onClick: submitAll,
        loading: submitting.value,
        round: ""
      }, {
        default: _withCtx(() => [
          _hoisted_48
        ]),
        _: 1
      }, 8, ["loading"])
    ])
  ]))
}
}

})